import { render, staticRenderFns } from "./StripeCheckoutEditor.vue?vue&type=template&id=48134092&scoped=true&"
import script from "./StripeCheckoutEditor.vue?vue&type=script&lang=js&"
export * from "./StripeCheckoutEditor.vue?vue&type=script&lang=js&"
import style0 from "./StripeCheckoutEditor.vue?vue&type=style&index=0&id=48134092&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48134092",
  null
  
)

export default component.exports